
import { format } from "date-fns";

export const formatDate = (dateString: string | null) => {
  if (!dateString) return '-';
  try {
    return format(new Date(dateString), 'dd/MM/yyyy');
  } catch (error) {
    return 'Date invalide';
  }
};
